module.exports = __webpack_public_path__ + "img/preview.fed7049a.webp";